import Vue from 'vue'
import VueRouter from 'vue-router'
import { store } from '../store/index'

import home from '../components/home.vue'
import videoPage from '../components/videoPage.vue'
import video_info from '../components/video_info.vue'
import user from '../components/user.vue'
import profiles from '../components/profiles.vue'
import profile_edit from '../components/profile_edit.vue'
import profile_disconect from '../components/profile_disconect.vue'
import login from '../components/login.vue'
import categories from '../components/categories.vue'
import category from '../components/category.vue'

//import items_list_page from '../components/items_list_page.vue'
import favorites from '../components/favorites.vue'
import contact from '../components/contact.vue'
import new_setup from '../components/new_setup.vue'
import webinar from '../components/webinar.vue'
import live from '../components/live.vue'
import login_profile from '../components/login_profile.vue'
import livePage from '../views/livePage.vue'

import ArticlePage from '../views/ArticlePage.vue'
import ResetPasswordPage from '../views/ResetPasswordPage.vue'

Vue.use(VueRouter)

const routes = [
    { path: '/', component: home, props: { footer: true, header: true} },
    { path: '/live', component: live, props: { footer: false, live: false} },
    { path: '/login_profile', component: login_profile, props: { footer: false, header: false} },
    { path: '/set_up/:id', component: new_setup, props: { footer: false, header: false} },
    { path: '/webinar/:id', component: webinar, props: { footer: false, header: false} },
    { path: '/item/:id', component: videoPage, props: { footer: false, header: false} },
    { path: '/item/:id/:eid', component: videoPage, props: { footer: false, header: false} },
    { path: '/user', component: user, props: { footer: true, header: true} },
    { path: '/user/profiles', component: profiles, props: { footer: true, header: true} },
    { path: '/user/profiles/insert', component: profile_edit, props: { footer: true, header: true} },
    { path: '/user/profiles/disconect', component: profile_disconect, props: { footer: true, header: true} },
    { path: '/user/profiles/edit/:id', component: profile_edit, props: { footer: true, header: true} },
    { path: '/login', component: login, props: { footer: false, header: false} },
    { path: '/login/:news?/prevpage/:prevpage?', component: login, props: { footer: false, header: false} },
    { path: '/info/:id', component: video_info, props: { footer: false, header: true} },

    { path: '/article/:id', component: ArticlePage, props: { footer: true, header: true } },

    
    { path: '/categories/:type', component: categories, props: { footer: true, header: true} },
    { path: '/category/:id', component: category, props: { footer: true, header: true} },
    { path: '/category/:id/type/:type?', component: category, props: { footer: true, header: true} },
    { path: '/favorites', component: favorites, props: { footer: true, header: true} },
    { path: '/contact', component: contact, props: { footer: true, header: true} },
    // /signup?plan=X — opens home shell with the signup modal in signup mode.
    // The beforeEach guard below commits open_signup to Vuex so App.vue opens the modal.
    { path: '/signup', component: home, props: { footer: true, header: true} },
    { path: '/livePage/:id', component: livePage, props: { footer: true, header: true} },
    { path: '/reset-password', component: ResetPasswordPage, props: { footer: false, header: false } },
]

if (process.env.NODE_ENV !== 'production') {
  const UiKit = () => import('../components/UiKit.vue');
  routes.push({ path: '/ui-kit', component: UiKit, name: 'ui-kit', props: { footer: false, header: false } });
}

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior: (to, from, savedPosition) => {
        if(savedPosition){
            return savedPosition;
        }else if(to.hash){
            return {
                selector: to.hash
            };
        }else{
            return { x: 0, y: 0 };
        }
    }
})
 
// When navigating INTO /signup (not already on it), open the signup modal via Vuex.
// When navigating AWAY from /signup, close the modal so signup_open doesn't persist.
// plan_id comes from ?plan= query param (0 = free).
router.beforeEach((to, from, next) => {
  if (to.path === '/signup' && from.path !== '/signup') {
    const plan_id = parseInt(to.query.plan) || 0;
    const step = plan_id > 0 ? 2 : 1;
    store.commit('open_signup', { step, plan_id });
  } else if (from.path === '/signup' && to.path !== '/signup') {
    store.commit('close_signup');
  }
  next();
});

export default router
